import React, { useState, useCallback } from "react"

export default function TokenInput({ onFetchMetadata }) {
  const [tokenId, setTokenId] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault()
      if (!tokenId || isLoading) return

      setIsLoading(true)
      try {
        await onFetchMetadata(tokenId)
      } catch (err) {
        console.error("Error fetching token:", err)
        alert("Error fetching token metadata")
      } finally {
        setIsLoading(false)
      }
    },
    [tokenId, isLoading, onFetchMetadata]
  )

  return (
    <form onSubmit={handleSubmit} className="mb-4">
      <div className="input-group">
        <input
          type="text"
          className="form-control form-control-lg rounded-start-3 pixel-font"
          placeholder="Enter Token ID"
          value={tokenId}
          onChange={(e) => setTokenId(e.target.value)}
          disabled={isLoading}
        />
        <button
          type="submit"
          className="btn btn-primary btn-lg px-4 rounded-end-3 pixel-font"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Loading...
            </>
          ) : (
            "Enter"
          )}
        </button>
      </div>
    </form>
  )
}
